import { render } from "./videoQuestion.vue?vue&type=template&id=6bc831b2&scoped=true"
import script from "./videoQuestion.vue?vue&type=script&lang=js"
export * from "./videoQuestion.vue?vue&type=script&lang=js"

import "./videoQuestion.vue?vue&type=style&index=0&id=6bc831b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc831b2"]])

export default __exports__